import CartAPICall from "../service/CartAPICall";
import store from "../storeWire";
import { SET_CART_WEB_ORDER_ID, SET_CART_LOADER_DATA_OBJECT, SET_CART_DATA, SET_CLEAR_VALIDATE_CART, } from "../store/slice/model/Cart";
import { __set, __remove } from "../store/axios_indicator";
import { isArray } from "underscore";
import System from "../helper/system";
import ProductInventoryPriceRepository from "./ProductInventoryPriceRepository";
import Constants from "src/helper/Constants";
import Helper from "../helper/Helper";
import ResponseMaker from "src/service/reponseMaker/productResponseMaker";
import { set_product_master_data } from "src/store/slice/model/ProductListing";

const { storageName: { CART_ID } } = System
const { systemModules: { CART }, testCSSURL, devCSSURL } = Constants
class CartRepository {

    fetchCartCount = async (params) => {
        let res = await new CartAPICall().getCartCount(params);
        return res;
    };
    fetchCartData = async (params) => {
        let res = await new CartAPICall().getCartFromServer(params);
        let dataHere = res.data ? res.data : [];
        if (res?.data) {

            if (dataHere && dataHere.length) {
                dataHere = dataHere.map((v) => {
                    v.ERPPartNumber = v.partNumber;
                    v.ManufacturerPartNumber = v.manufacturerPartNumber;
                    v.ERPMFRPartNumber = v.erpMfrPartNumber;
                    v.ItemNumber = v.itemNumber;
                    v.CUSTOMER_PART_NUMBER = v.cpn;
                    v.isProductAvailableFromMainAPI = true

                    // if (v.subtotal) {
                    //     v.subtotal = Math.round((v.subtotal + Number.EPSILON) * 100) / 100
                    // }

                    if (v.quantity) {
                        let totalQuantity = 0;
                        let shipmentDetail = v.scheduleDetails;
                        if (isArray(shipmentDetail) && shipmentDetail.length > 0) {
                            shipmentDetail.map((p, j) => {
                                totalQuantity = totalQuantity + p.quantity;
                            });
                            v.isScheduleTotalQtyValid = (totalQuantity > v.quantity) ? false : true
                        } else {
                            v.isScheduleTotalQtyValid = true
                        }
                    }
                    // NOTE: View cart optimization logic

                    if (System.isCallFromCart() && params?.miniCart !== true) {
                        if (v?.product) {
                            let product = v.product

                            const CPNData = product?.customerPartNumbers.map(item => {
                                return Object.keys(item).reduce((acc, key) => {
                                    acc[key.toUpperCase()] = item[key];
                                    return acc;
                                }, {});
                            });

                            let res = {
                                data: {
                                    products: [{
                                        ItemNumber: v.ItemNumber,
                                        ERPMFRPartNumber: v.ERPMFRPartNumber,
                                        CustomerPartNumbers: CPNData,
                                        ECCNCode: product.eccnCode,
                                        distributor: product.distributor,
                                        EndofLifeFlag: product.endofLifeFlag,
                                        ERPPartNumber: product.erpPartNumber,
                                        ExcessInventoryFlag: product.excessInventoryFlag,
                                        FactoryLeadTime: product.factoryLeadTime,
                                        HTSCode: product.htsCode,
                                        NCNRFlag: product.ncnrFlag,
                                        NPIFlag: product.npiFlag,
                                        ObsoleteFlag: product.obsoleteFlag,
                                        PackagingTypeCode: product.packagingTypeCode,
                                        QtyMin: product.qtyMin,
                                        QtyMult: product.qtyMult,
                                        ROHSCompliantCode: product.rohsCompliantCode,
                                        sap_tla_type_cd: product.sap_tla_type_cd,
                                        SAPMaterialPricingGroupCode: product.sapMaterialPricingGroupCode,
                                        ScheduleBCode: product.scheduleBCode,
                                        ShortDescription: product.shortDescription,
                                        TopSellerFlag: product.topSellerFlag,
                                        WebOnlyFlag: product.webOnlyFlag,
                                        MDMMaterialID: v.mdmMaterialId,
                                        default_plant: v.default_plant,
                                        IsTariffEligible: product.isTariffEligible,
                                        factory_qoh: product.factory_qoh,
                                        exists_in_sap: product.exists_in_sap,
                                        ManufacturerPartNumber: v.manufacturerPartNumber,
                                        SoftwareDownloadFlag: v.isSoftwareDownloadable,
                                        custom_reel_flag: product.custom_reel_flag,
                                        HazardousFlag: product.hazardousFlag
                                    }]
                                }
                            };
                            // res.data.products = [{...v?.product, ItemNumber: v.ItemNumber, ERPMFRPartNumber: v.ERPMFRPartNumber}];
                            let res_made = new ResponseMaker(res).process().run().get();
                            // res_made.config = param;
                            store.dispatch(set_product_master_data(res_made));
                        } else {
                            v.isProductAvailableFromMainAPI = false
                        }

                        if (v?.price) {
                            let res = {}
                            const { quantityPricingVO, itemId, ...rest } = v?.price;
                            const pricingData = quantityPricingVO.map((obj) => {
                                const { resale, resaleSource, ...rest } = obj;
                                return {
                                    marketPrice: resale,
                                    priceSource: resaleSource,
                                    ...rest
                                };
                            });

                            // remove which have no market price and set in quantity ascending order also filter by selected currency
                            let pricing = pricingData
                                .filter(item => item.marketPrice !== undefined && item.marketPrice !== null && item.marketPrice !== 0 && item.currency === window.mct)
                                .sort((a, b) => a.quantity - b.quantity);

                            res[v.ItemNumber] = {
                                ...rest,
                                pricing,
                                ItemNumber: v.ItemNumber
                            }

                            if (res && Object.entries(res).length) {
                                new ProductInventoryPriceRepository().setPricingState(res)
                            }
                        }

                        const resObj = {}
                        resObj[v.ItemNumber] = { inventoryQty: 0, factoryStock: parseInt(v?.product?.factory_qoh) };

                        if (v?.inventory && v.inventory.length > 0) {

                            v?.inventory.map(p => {
                                if (p.plant === v.default_plant) {
                                    resObj[v.ItemNumber] = { inventoryQty: p.availableQuantity ? parseInt(p.availableQuantity) : 0, factoryStock: parseInt(v?.product?.factory_qoh) }
                                }
                            })

                        }

                        if (v?.newarkStockDetails && v.newarkStockDetails.length > 0) {
                            v?.newarkStockDetails.map(p => {
                                resObj[v.ItemNumber] = { inventoryQty: p.regionalBreakdown?.level ? parseInt(p.regionalBreakdown.level) : parseInt(p.level), factoryStock: parseInt(v?.product?.factory_qoh) }
                            })

                        }

                        if (resObj && Object.entries(resObj).length)
                            new ProductInventoryPriceRepository().setinventoryState(resObj)
                    }

                    return v;
                })
            }
        } else {
            sessionStorage.removeItem(CART_ID)
        }
        if (res?.orderId) {
            this.setWebOrderID(res.orderId)
        }
        store.dispatch(SET_CART_DATA({
            CART_DATA: dataHere
        }))

        return res;
    };

    setWebOrderID = async (webOrderId) => {
        if (webOrderId) {
            store.dispatch(SET_CART_WEB_ORDER_ID({
                WEB_ORDER_ID: webOrderId
            }));
        }
    };


    replaceCartInBulk = async (params, fromBom = false) => {
        let server_response = await new CartAPICall().replaceCartInBulk(params);
        const ItemNumbers = params?.cartItems.map(obj => obj.ItemNumber)
        const result = server_response.data.cartItems.filter(item => ItemNumbers.includes(item.itemNumber))
        if (fromBom === true) {
            System.popup('AddedToCartBomPopup', { cartData: result, isCartBOM: true })
        } else {
            let response_data = {}
            response_data.data = result[0]
            if (server_response) {
                System.popup('AddedToCartNotification', { data: { server_response: response_data } })
            }
        }
    }

    backorderNotAvailable = (single_product) => {
        if (single_product?.ObsoleteFlag || single_product?.EndOfLifeFlag || single_product?.specialPriceFlag || single_product?.constrainPartFlag || single_product?.isPartnerDistributor || single_product?.isNewarkDistributor || single_product?.ExcessInventoryFlag) {
            return true
        }
    }

    addToCartServer = async (params, isFrom, productData, isManuallyAddCart) => {
        store.dispatch(SET_CART_LOADER_DATA_OBJECT({}))
        let server_response = ''
        server_response = await new CartAPICall().addToCartServer(params);
        if (server_response) {
            __set('CART_API_CALL');
            let data = {
                server_response,
                params
            }
            if (server_response?.data?.isExists === true) {
                System.popup('CartItemReplacePopup', { product: productData, cartReplaceItem: params, isFrom: isFrom, isFromManualCart: isManuallyAddCart })
            } else if ((server_response?.data?.isBackOrderConfirmation === true && this.backorderNotAvailable(productData))) {
                System.popup('BackorderNotAvailable', { singleProduct: params })
            } else if (server_response?.data?.isBackOrderConfirmation === true) {
                System.popup('ProductBackorderedPopup', { product: productData, isFrom: isFrom, addToCartParam: params, isFromManualCart: isManuallyAddCart, cartRes: server_response?.data })
            } else {

                if (isManuallyAddCart) {
                    await new CartRepository().fetchCartData();
                } else {

                    System.popup('AddedToCartNotification', { data: data })
                }
            }

            __remove('CART_API_CALL');
        }
        return server_response;
    };

    addCartInBulk = async (items) => {

        if (items && Object.entries((items).length > 0)) {
            let res = await new CartAPICall().addCartInBulk(items)

            const filteredItems = res.data.cartItems.filter(v =>
                items.cartItems.some(p => v.itemNumber === p.ItemNumber)
            ).map(v => {
                // Find the corresponding item in items.cartItems
                const matchedItem = items.cartItems.find(p => v.itemNumber === p.ItemNumber);
                // Add the ShortDescription to the object
                return { ...v, ShortDescription: matchedItem.ShortDescription };
            });

            return filteredItems
        }


        return false
    };

    updateToCartServer = async (params, fireUpdateEvent = true) => {
        __set('CART_OPERATION_API_CALL')
        let server_response = await new CartAPICall().updateToCartServer(params);
        if (server_response && fireUpdateEvent === true) {

            await new CartRepository().fetchCartData()
        }
        __remove('CART_OPERATION_API_CALL')
        return server_response;
    };

    clearAllCartFromServer = async () => {
        store.dispatch(SET_CART_DATA({
            CART_SUB_TOTAL: 0
        }))
        store.dispatch(SET_CLEAR_VALIDATE_CART({}))
        return await new CartAPICall().clearAllCartFromServer();
    };

    clearSingleCartProduct = async (params) => {
        store.dispatch(SET_CLEAR_VALIDATE_CART({}))
        let server_response = await new CartAPICall().clearSingleCartProduct(params.cartDetailId);
        if (server_response) {
            await new CartRepository().fetchCartData(params);
        }
        return server_response;
    };

    scheduleShippingApply = async (params) => {
        let server_response = await new CartAPICall().scheduleShippingApply(params);
        if (server_response) {
            __set('CART_API_CALL');
            await new CartRepository().fetchCartData({ minicart: true });
            __remove('CART_API_CALL');
        }
        return server_response;
    };

    updateBackOrderQuantityToCartServer = async (cartDetailItems) => {
        let server_response = await new CartAPICall().updateBackOrderQuantityToCartServer(cartDetailItems);
        if (server_response) {
            await new CartRepository().fetchCartData();
        }
        return server_response;
    };


    checkItemExistsInCart = async (checkItemParam) => {
        return await new CartAPICall().checkItemExistsInCart(checkItemParam);
    };

    getDisplayStatusButton = (Product, Pricing, Inventory, type, extraParams) => {
        let inventory = new ProductInventoryPriceRepository().getInventoryByDistributor(Product, Inventory)
        if (type === 'cart') {
            if (!Product || Pricing?.length < 1) {
                return false
            } else {
                if (Product?.AllocationFlag || Product?.PIMBlock === 'E') {
                    return false
                } else if (Product?.ObsoleteFlag || Product?.EndOfLifeFlag || Product?.specialPriceFlag) {
                    return inventory > 0 ? true : false
                } else {
                    return true
                }
            }
        } else if (type === 'quoteLink') {
            if (Product?.ObsoleteFlag || Product?.EndOfLifeFlag || Product?.specialPriceFlag) {
                return (inventory <= 0 || Pricing?.length < 1) ? false : true
            } else {
                return Product?.isAvnetDistributor ? true : false
            }
        } else if (type === 'quote') {
            if (Product?.ObsoleteFlag || Product?.EndOfLifeFlag || Product?.specialPriceFlag) {
                return (inventory <= 0 || Pricing?.length < 1) ? false : true
            } else {
                if (Product?.AllocationFlag || Product?.PIMBlock === 'E' || Pricing?.length < 1 || Product?.QtyMin <= 0 || Product?.QtyMult <= 0) {
                    return true
                } else {
                    return false
                }
            }
        } else if (type === 'contactUs') {
            if (Product?.ObsoleteFlag || Product?.EndOfLifeFlag || Product?.specialPriceFlag) {
                return (inventory <= 0 || Pricing?.length < 1)
            } else {
                return false
            }
        }

    }

    getValidateCartFromServer = async (params) => {
        return await new CartAPICall().getValidateCartFromServer(params);
    };

    fetchCartTax = async (params) => {
        return await new CartAPICall().fetchCartTax(params);
    };

    addComplianceData = async (params) => {
        return await new CartAPICall().addComplianceData(params);
    }
    getComplianceData = async (params) => {
        let data = []
        let complianceData = await new CartAPICall().getComplianceData(params);

        data = complianceData
        data?.questions?.forEach((item, index) => {

            if (item.questionType === 'RAD' && item.questionId === 134) {
                const obj = {
                    1: "Research, design and development of electronic components",
                    2: "Contract manufacturer of electronic components",
                    3: "Test of electronic components",
                    4: "Manufacturer of electronic components",
                    5: "Manufacturer of automobile components",
                    6: "Manufacturer of medical equipment",
                    7: "Distributor of electronic components",
                    8: "Not a corporation, purchased for individual use in personal electronic goods",
                    9: "University/Educational Facility"
                }
                item?.options.forEach((option, i) => {
                    item.fieldName = "company";
                    option.optionText = obj[option.optionOrder] ? obj[option.optionOrder] : "Other"
                })
            } else if (item.questionType === 'TXT' && item.questionId === 135) {
                item.fieldName = "other"
            } else if (item.questionType === 'RAD' && item.questionId === 136) {
                const obj = {
                    1: "Civil",
                    2: "Military",
                }
                item?.options.forEach((option, i) => {
                    item.fieldName = "typeOfProduct";
                    option.optionText = obj[option.optionOrder] ? obj[option.optionOrder] : "Governement"

                })
            } else if (item.questionType === 'RAD' && (item.questionId === 138 || item.questionId === 161)) {
                item?.options.forEach((option, i) => {
                    item.fieldName = item.questionId === 138 ? "exportProduct" : "freightForwarder"
                    if (option.optionOrder === 1) {
                        option.optionText = "Yes"
                    } else if (option.optionOrder === 2) {
                        option.optionText = "No"
                    }
                })
            } else if (item.questionType === 'RAD' && item.questionId === 170) {
                item?.options.forEach((option, i) => {
                    item.fieldName = "condition"
                    if (option.optionOrder === 1) {
                        option.optionText = "I Agree"
                    } else if (option.optionOrder === 2) {
                        option.optionText = "I Decline"
                    }
                })
                item.description = item.questionText
                item.questionText = "I certify the above facts are true and correct. I shall make prompt notification to Avnet of any change to the facts or intentions set forth above."
            }
        })

        return data
    }
    mergeGuestCartItems = async () => {
        return await new CartAPICall().mergeGuestCartItems();
    };

    getPaymentToken = async () => {
        const hostURL = Helper.getHostURL();
        const cssURL = hostURL.includes("test") ? testCSSURL : devCSSURL;
        return await new CartAPICall().getPaymentToken(hostURL, cssURL);
    }
}

export default CartRepository;